import axiosInstance from './axiosInstance';

const PermissionAPI = {
    getUserPermissions: () => axiosInstance.get('updatedUserData'),
};

export default PermissionAPI;
